"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var classnames_1 = __importDefault(require("classnames"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var style_scss_1 = __importDefault(require("./style.scss"));
var getPositions = function (positionClasses, el, tooltip) {
    var xClass = positionClasses.xClass, yClass = positionClasses.yClass;
    var elementRect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
    var tooltipRect = tooltip === null || tooltip === void 0 ? void 0 : tooltip.getBoundingClientRect();
    var elLeft = (elementRect === null || elementRect === void 0 ? void 0 : elementRect.left) || 0;
    var elWidth = (elementRect === null || elementRect === void 0 ? void 0 : elementRect.width) || 0;
    var elTop = (elementRect === null || elementRect === void 0 ? void 0 : elementRect.top) || 0;
    var elHeight = (elementRect === null || elementRect === void 0 ? void 0 : elementRect.height) || 0;
    var tooltipWidth = (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.width) || 0;
    var tooltipHeight = (tooltipRect === null || tooltipRect === void 0 ? void 0 : tooltipRect.height) || 0;
    var left = elLeft + elWidth / 2 - tooltipWidth / 2;
    if (xClass === 'left') {
        left = elLeft - tooltipWidth;
        if (yClass === 'top' || yClass === 'bottom') {
            left = left + elWidth;
        }
    }
    else if (xClass === 'right') {
        left = elLeft;
        if (yClass !== 'top' && yClass !== 'bottom') {
            left = elLeft + elWidth;
        }
    }
    var top = elTop + elHeight / 2 - tooltipHeight / 2;
    if (yClass === 'top') {
        top = elTop - tooltipHeight;
    }
    else if (yClass === 'bottom') {
        top = elTop + elHeight;
    }
    return { left: left, top: top };
};
var tipPosition = function (positionClasses, el) {
    var xClass = positionClasses.xClass, yClass = positionClasses.yClass;
    var elementRect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
    var elWidth = (elementRect === null || elementRect === void 0 ? void 0 : elementRect.width) || 0;
    var left = 'auto';
    var right = 'auto';
    if (xClass === 'left' && (yClass === 'top' || yClass === 'bottom')) {
        right = "".concat(elWidth / 2 - 5, "px");
    }
    else if (xClass === 'right' && (yClass === 'top' || yClass === 'bottom')) {
        left = "".concat(elWidth / 2 - 5, "px");
    }
    else if (!xClass) {
        left = '50%';
    }
    return { left: left, right: right };
};
var ToolTip = function (_a) {
    var childId = _a.childId, children = _a.children, content = _a.content, _b = _a.position, position = _b === void 0 ? 'top' : _b, hoverOpenDelay = _a.hoverOpenDelay;
    if (!content) {
        return children;
    }
    var id = (0, react_1.useRef)("botpress-tooltip-".concat((0, uniqueId_1.default)()));
    var timeout = (0, react_1.useRef)(null);
    var tooltipRef = (0, react_1.useRef)(null);
    var tipRef = (0, react_1.useRef)(null);
    var pastShow = function (el) {
        var _a;
        var elementRect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
        var tooltipRect = (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (tooltipRect) {
            var docWidth = document.documentElement.clientWidth, docHeight = document.documentElement.clientHeight;
            var rx = elementRect.x + elementRect.width; // most right x
            var lx = elementRect.x; // most left x
            var ty = elementRect.y; // most top y
            var by = elementRect.y + elementRect.height; // most bottom y
            var overflowYMiddle = (tooltipRect.height - elementRect.height) / 2;
            var overflowXMiddle = (tooltipRect.width - elementRect.width) / 2;
            overflowXMiddle = overflowXMiddle < 0 ? 0 : overflowXMiddle;
            var canBeXMiddle_1 = rx + overflowXMiddle <= docWidth && lx - overflowXMiddle >= 0;
            var canBeRight = rx + tooltipRect.width <= docWidth;
            var canBeLeft_1 = lx - tooltipRect.width >= 0;
            var canBeYMiddle_1 = ty - overflowYMiddle >= 0 && by + overflowYMiddle <= docHeight;
            var canBeAbove_1 = ty - tooltipRect.height >= 0;
            var canBeBellow = by + tooltipRect.height <= docHeight;
            var xClass_1;
            var yClass_1;
            var checkXPosition = function () {
                if (!canBeXMiddle_1) {
                    if (canBeLeft_1) {
                        return 'left';
                    }
                    else {
                        return 'right';
                    }
                }
                return '';
            };
            var checkYPosition = function () {
                if (!canBeYMiddle_1) {
                    if (canBeAbove_1) {
                        return 'top';
                    }
                    else {
                        return 'bottom';
                    }
                }
                return '';
            };
            switch (position) {
                case 'top':
                    yClass_1 = 'top';
                    if (!canBeAbove_1) {
                        yClass_1 = 'bottom';
                    }
                    xClass_1 = checkXPosition();
                    break;
                case 'bottom':
                    yClass_1 = 'bottom';
                    if (!canBeBellow) {
                        yClass_1 = 'top';
                    }
                    xClass_1 = checkXPosition();
                    break;
                case 'left':
                    xClass_1 = 'left';
                    if (!canBeLeft_1) {
                        xClass_1 = 'right';
                    }
                    yClass_1 = checkYPosition();
                    break;
                case 'right':
                    xClass_1 = 'right';
                    if (!canBeRight) {
                        xClass_1 = 'left';
                    }
                    yClass_1 = checkYPosition();
                    break;
            }
            var _b = getPositions({ xClass: xClass_1, yClass: yClass_1 }, el, tooltipRef.current), left = _b.left, top_1 = _b.top;
            var tipPos_1 = tipPosition({ xClass: xClass_1, yClass: yClass_1 }, el);
            var inlineStyle_1 = {
                left: "".concat(left, "px"),
                top: "".concat(top_1, "px")
            };
            setTimeout(function () {
                var _a, _b, _c, _d, _e, _f, _g;
                (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.classList.add(style_scss_1.default.visible);
                if (xClass_1) {
                    (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.classList.add(xClass_1);
                }
                if (yClass_1) {
                    (_c = tooltipRef.current) === null || _c === void 0 ? void 0 : _c.classList.add(yClass_1);
                }
                (_d = tooltipRef.current) === null || _d === void 0 ? void 0 : _d.style.left = inlineStyle_1.left;
                (_e = tooltipRef.current) === null || _e === void 0 ? void 0 : _e.style.top = inlineStyle_1.top;
                (_f = tipRef.current) === null || _f === void 0 ? void 0 : _f.style.left = tipPos_1.left;
                (_g = tipRef.current) === null || _g === void 0 ? void 0 : _g.style.right = tipPos_1.right;
            }, hoverOpenDelay || 0);
        }
    };
    var show = function (e) {
        document.addEventListener('mousemove', mouseMove);
        clearTimeout(timeout.current);
        handleHtmlRendering();
        pastShow(e.currentTarget);
    };
    var mouseMove = function (e) {
        var _a;
        if (!((_a = e.target) === null || _a === void 0 ? void 0 : _a.closest("#".concat(childId || "".concat(id.current, "-trigger"))))) {
            hide();
        }
    };
    var handleHtmlRendering = function (classNames, inlineStyle, tipPos) {
        if (classNames === void 0) { classNames = ''; }
        if (inlineStyle === void 0) { inlineStyle = {}; }
        if (tipPos === void 0) { tipPos = {}; }
        var body = document.getElementsByTagName('body')[0];
        var toolTip = document.getElementById(id.current);
        var div = document.createElement('div');
        div.setAttribute('id', id.current);
        if (toolTip) {
            body.replaceChild(div, toolTip);
        }
        else {
            body.appendChild(div);
        }
        react_dom_1.default.render(react_1.default.createElement("div", { ref: tooltipRef, className: (0, classnames_1.default)(style_scss_1.default.tooltip, classNames), style: inlineStyle },
            react_1.default.createElement("div", { ref: tipRef, className: "tooltipArrow", style: tipPos }),
            react_1.default.createElement("div", { className: "tooltipInner" }, content)), div);
    };
    var hide = function () {
        var _a;
        document.removeEventListener('mousemove', mouseMove);
        (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove(style_scss_1.default.visible);
        var body = document.getElementsByTagName('body')[0];
        clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            var div = document.getElementById(id.current);
            if (div) {
                body.removeChild(div);
            }
        }, 300);
    };
    return (0, react_1.cloneElement)(react_1.Children.only(children), {
        id: childId || "".concat(id.current, "-trigger"),
        onMouseEnter: show,
        onMouseLeave: hide
    });
};
exports.default = ToolTip;
